// System settings validation -- iteration 076
import { z } from "zod";

export const updateSystemSettingSchema = z.object({
  value: z.string(),
});

export type UpdateSystemSettingInput = z.infer<typeof updateSystemSettingSchema>;
